
import React from 'react';

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  children: React.ReactNode;
  error?: string;
  isRecommendation?: boolean;
}

const Select: React.FC<SelectProps> = ({ label, id, children, error, isRecommendation, ...props }) => {
  const hasError = error && !isRecommendation;
  const hasRecommendation = error && isRecommendation;
  
  return (
    <div className="min-w-0">
      <label htmlFor={id} className="block text-sm font-medium text-gray-300 mb-1">
        {label}
        {props.required && <span className="text-red-400 ml-1">*</span>}
      </label>
      <select
        id={id}
        className={`w-full min-w-0 max-w-full box-border bg-gray-700 border rounded-md shadow-sm px-3 py-2 text-white focus:outline-none focus:ring-2 ${
          hasError 
            ? 'border-red-500 focus:ring-red-500 focus:border-red-500' 
            : hasRecommendation
            ? 'border-yellow-500 focus:ring-yellow-500 focus:border-yellow-500'
            : 'border-gray-600 focus:ring-indigo-500 focus:border-indigo-500'
        }`}
        {...props}
      >
        {children}
      </select>
      {error && (
        <p className={`mt-1 text-sm ${hasError ? 'text-red-400' : 'text-yellow-400'}`}>
          {hasError ? '❌ ' : '💡 '}{error}
        </p>
      )}
    </div>
  );
};

export default Select;
